import { UserAuthData } from "../models/auth";

export const getBusinessUidFromUserAuth = (data: UserAuthData): string | null => {
  if (data.DefaultBusiness) {
    return data.DefaultBusiness.Uid;
  }

  if (data.Businesses) {
    return data.Businesses[0]?.Uid
  }

  return null;
}
